<script lang="ts">
  import { ChartColumnIncreasing, Flame, BadgeCheck, Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
</script>

<div
  class="mt-8 mx-auto grid max-w-2xl grid-cols-1 gap-x-2 gap-y-8 lg:mx-0 lg:max-w-none"
>
  <div class="lg:pr-8">
    <div class="lg:max-w-3xl mx-auto bg-white shadow rounded">
      <div class="py-4 px-6">
        <p
          class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl flex justify-start items-center"
        >
          <Lock class="size-7 text-red-800 mr-2" />
          Accomplishments Page
        </p>
        <p class="mt-6 text-lg/8 text-gray-700">
          The Accomplishments Page is not available at your current Free
          Subscription level. Please upgrade to the Standard Subscription to
          access all the valuable features including the following:
        </p>
        <dl
          class="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none"
        >
          <div class="relative pl-9">
            <dt class="inline font-semibold text-gray-900">
              <ChartColumnIncreasing
                class="size-6 absolute top-1 left-1 text-blue-600"
              />
              View Your Stats
            </dt>
            <dd class="inline">
              See how many recognitions you have sent and received and how many
              goal and task progress reports you have submitted.
            </dd>
          </div>
          <div class="relative pl-9">
            <dt class="inline font-semibold text-gray-900">
              <Flame class="size-6 absolute top-1 left-1 text-blue-600" />
              Streaks
            </dt>
            <dd class="inline">
              See your current streaks for recognitions and progress reports.
            </dd>
          </div>
          <div class="relative pl-9">
            <dt class="inline font-semibold text-gray-900">
              <BadgeCheck class="size-6 absolute top-1 left-1 text-blue-600" />

              Badges
            </dt>
            <dd class="inline">View all the badges you have earned.</dd>
          </div>
        </dl>
      </div>
      <div class="py-4 px-8 mt-6 flex justify-end border-t border-gray-200">
        <a
          href={`/plans/${appStore.plan.id}/admin`}
          class="rounded-md bg-green-600 px-3.5 py-2.5 text-base font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
          >Upgrade Now</a
        >
      </div>
    </div>
  </div>
</div>
